<div class="with-taly-main">
  <div class="col-5">
    <taly-order-details />
    <taly-payment-method [type]="'withtaly'" />
    <div class="instalments-wrapper">
      <taly-instalments [isLightTheam]="true" [amounts]="100" />
    </div>
  </div>
  <div class="col-5 img-bg">
    <img src="assets/images/with-taly.svg" alt="" />
  </div>
</div>
